<template>
  <div>
    <modal :show.sync="modals.classic">
      <h4 slot="header" class="title title-up">
        {{ $t("app.modules.candidates.headers.details_candidate") }}
      </h4>

      <div class="row">
        <div :class="sizes">
          <h4>
            <small
              ><b>{{
                $t("app.modules.candidates.headers.business_name")
              }}</b></small
            >
          </h4>

          <h5>
            <small>{{ item.compañia }}</small>
          </h5>
        </div>

        <div :class="sizes">
          <h4>
            <small
              ><b>{{ $t("app.modules.candidates.headers.rfc") }}</b></small
            >
          </h4>
          <h5>
            <small>{{ item.rfc }}</small>
          </h5>
        </div>

        <div :class="sizes">
          <h4>
            <small
              ><b>{{ $t("app.modules.candidates.headers.company") }}</b></small
            >
          </h4>
          <h5>
            <small>{{ item.razonSocial }}</small>
          </h5>
        </div>

        <div :class="sizes">
          <h4>
            <small
              ><b>{{
                $t("app.modules.candidates.headers.applicants_name")
              }}</b></small
            >
          </h4>
          <h5>
            <small>{{ item.nombreContacto }}</small>
          </h5>
        </div>

        <div :class="sizes">
          <h4>
            <small
              ><b>{{ $t("app.modules.candidates.headers.country") }}</b></small
            >
          </h4>
          <h5>
            <small>{{ item.pais }}</small>
          </h5>
        </div>

        <div :class="sizes">
          <h4>
            <small
              ><b>{{ $t("app.modules.candidates.headers.state") }}</b></small
            >
          </h4>
          <h5>
            <small>{{ item.estado }}</small>
          </h5>
        </div>

        <div :class="sizes">
          <h4>
            <small
              ><b>{{ $t("app.modules.candidates.headers.phone") }}</b></small
            >
          </h4>
          <h5>
            <small>{{ item.telefono }}</small>
          </h5>
        </div>

        <div :class="sizes">
          <h4>
            <small
              ><b>{{ $t("app.modules.candidates.headers.mail") }}</b></small
            >
          </h4>
          <h5>
            <small>{{ item.email }}</small>
          </h5>
        </div>

        <div :class="sizes">
          <h4>
            <small
              ><b>{{
                $t("app.modules.candidates.headers.interested_product")
              }}</b></small
            >
          </h4>
          <h5>
            <small>{{ item.productoInteres }}</small>
          </h5>
        </div>

        <div :class="sizes">
          <h4>
            <small
              ><b>{{ $t("app.modules.candidates.headers.quantity") }}</b></small
            >
          </h4>
          <h5>
            <small>{{ item.cantidad }}</small>
          </h5>
        </div>

        <div :class="sizes">
          <h4>
            <small
              ><b>
                {{ $t("app.modules.candidates.headers.commentary") }}</b
              ></small
            >
          </h4>
          <h5>
            <small>{{ item.comentarios }}</small>
          </h5>
        </div>

        <div :class="sizes">
          <h4>
            <small
              ><b>
                {{ $t("app.modules.candidates.headers.application_date") }}</b
              ></small
            >
          </h4>
          <h5>
            <small>{{ item.fechaEnvio }}</small>
          </h5>
        </div>

        <div :class="sizes">
          <h4>
            <small
              ><b>
                {{
                  $t("app.modules.candidates.headers.sales_executive_assigned")
                }}</b
              ></small
            >
          </h4>
          <h5>
            <small>{{
              asigned(item.prospectoStatus)
                ? item.nombre
                : $t("app.general.unassigned")
            }}</small>
          </h5>
        </div>
        <template v-if="item.idEstadoProspecto == 4">
          <div :class="sizes">
            <h4>
              <small
                ><b>
                  {{
                    $t("app.modules.candidates.headers.reason_for_rejection")
                  }}</b
                ></small
              >
            </h4>
            <h5>
              <small>{{ item.motivoRechazo }}</small>
            </h5>
          </div>
        </template>
        <div :class="sizes">
          <h4>
            <small
              ><b>{{
                $t("app.modules.candidates.headers.date_assignment")
              }}</b></small
            >
          </h4>
          <h5>
            <small>{{
              asigned(item.prospectoStatus) ? item.fechaAsignacion : ""
            }}</small>
          </h5>
        </div>
      </div>
      <template
        slot="footer"
        style="background-color: #fbf6f6;  margin-top: 10px; padding-top: 20px;border-top: outset;"
      >
        <template>
          <n-button
            v-if="item.idEstadoProspecto == 2 && item.permisos.rechazar"
            type="primary"
            @click.native="confirmAction('refuse')"
            >{{ this.$t("app.modules.candidates.headers.rejection") }}</n-button
          >
          <n-button
            v-if="item.idEstadoProspecto == 2 && item.permisos.aceptar"
            @click.native="confirmAction('accept')"
            type="success"
            >{{ this.$t("app.modules.candidates.headers.accept") }}</n-button
          >
        </template>
      </template>
    </modal>
  </div>
</template>
<script>
export default {
  components: {
    // ConfirmarAccion: () => import("./confirmarAccion")
  },
  data() {
    return {
      sizes: "col-md-6 col-sm-12",
      item: { permisos: {} },
      modals: {
        classic: false
      },
      description: ""
    };
  },
  mounted() {
    EventBus.$on("prospectos-detalles", async item => {
      this.item = item;
      console.log(this.item);
      this.modals.classic = true;
    });
  },
  methods: {
    asigned(value) {
      var response = false;
      if (value > 1) {
        response = true;
      }
      return response;
    },
    async updateCandidate() {
      let payload = {
        id: 0,
        claveIdioma: "es",
        usuario: 0,
        prospecto: this.item
      };
      payload.prospecto.fechaEnvio = "2020-11-05T16:52:36.244Z";
      payload.prospecto.fechaAsignacion = "2020-11-05T16:52:36.244Z";
      await this.$http
        .put(route("Prospectos/autorizarRechazar"), payload)
        .then(
          async response => {
            if (response.body.code === 200) {
              this.notifyMessage("success", this.$t("app.promps.save_success"));
              this.modals.classic = false;
              EventBus.$emit("reload-items");
            } else {
              this.notifyMessage("danger", this.$t("app.promps.error"));
            }
          },
          error => {
            this.notifyMessage("danger", this.$t("app.promps.error"));
          }
        )
        .finally(() => {});
    },
    async confirmAction(action) {
      if (action == "accept") {
        this.$swal
          .fire({
            cancelButtonText: this.$t("app.buttons.cancel"),
            confirmButtonText: this.$t("app.buttons.confirm"),
            title: this.$t("app.modules.candidates.headers.accept"),
            text: this.$t("app.modules.candidates.headers.accept_text"),
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33"
          })
          .then(async result => {
            if (result.isConfirmed) {
              // Guardar el registro
              this.item.prospectoStatus = 3;
              await this.updateCandidate();
            }
          });
      } else {
        const { value: text } = await this.$swal.fire({
          input: "textarea",
          cancelButtonText: this.$t("app.buttons.cancel"),
          confirmButtonText: this.$t("app.buttons.save"),
          title: this.$t("app.modules.candidates.headers.rejection"),
          inputPlaceholder: this.$t(
            "app.modules.candidates.headers.description_of_rejection"
          ),
          inputAttributes: {
            "aria-label": this.$t(
              "app.modules.candidates.headers.description_of_rejection"
            )
          },
          showCancelButton: true,
          inputValidator: value => {
            if (!value) {
              return this.$t(
                "app.modules.candidates.headers.description_of_rejection"
              );
            }
          }
        });
        if (text) {
          this.item.prospectoStatus = 4;
          this.item.motivoRechazo = text;

          // Guardar el registro
          await this.updateCandidate();
        }
      }
    }
  }
};
</script>
<style>
.extended-forms .el-select {
  width: 100%;
  margin-bottom: 30px;
}
.card .alert {
  position: relative !important;
  width: 100%;
}

.modal-content .modal-header {
  padding-bottom: 24px;
  box-shadow: 0px 2px 5px 0px #00000021;
}

.modal-content .modal-body + .modal-footer {
  padding-top: 20px !important;
  background-color: #efefefb3;
}
</style>
